import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { Content } from '../../../providers/api/dtos';
import { getPropertyAvailableAssets, PropertyAvailableAssetsFilters } from '../../../providers/api/property/propertyProvider';

export const PROPERTY_AVAILABLE_ASSETS_RID = '/properties/:id/available-assets';

export function usePropertyAvailableAssets(
  propertyId?: number,
  filters?: PropertyAvailableAssetsFilters,
  options?: SWRConfiguration<Content[], AxiosError>,
): SWRResponse<Content[], AxiosError> {
  const key = propertyId ? [PROPERTY_AVAILABLE_ASSETS_RID, propertyId, filters] : null;

  return useSWR(key, () => getPropertyAvailableAssets(propertyId!, filters), options);
}
